import { Injectable } from '@angular/core';
import { ApplicationIDP } from 'src/app/model/application-idp.modals';
import { IdentityProvider } from 'src/app/model/idp.modals';
import { base } from '../base-service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IdpService extends base {
  constructor(private httpClient: HttpClient) {
    super();
   }
  add(model:IdentityProvider){
  return this.httpClient.post(this.serverUrl+"idp/add-idp",model,this.httpHeaders);
  }
  getAllIdps(){
   return this.httpClient.get(this.serverUrl+"idp/get-all-idps",this.httpHeaders);
  }
  getAppIdps(appId:any) {
    return this.httpClient.get(this.serverUrl+"idp/get-all-idps/"+appId,this.httpHeaders);
  }

  addIdps(model:ApplicationIDP) {
    return this.httpClient.post(this.serverUrl+"idp/add-application-idp",model,this.httpHeaders);
  }
  getIdpOfApplcationById(id:any){
    return this.httpClient.get(this.serverUrl+"idp/application-idp/"+id,this.httpHeaders);
  }
  update(model:ApplicationIDP){
    return this.httpClient.post(this.serverUrl+"idp/update-applicationIdp",model,this.httpHeaders);
  }
  delete(idpId:any){
    return this.httpClient.delete(this.serverUrl+"idp/app-idp/"+idpId);
  }
  getIdpSettings(id:any){
    return this.httpClient.get(this.serverUrl+'idp/get-idp-settings/'+id)
  }
  getCLientIdps(clientId:string){
    return this.httpClient.get(this.serverUrl+'idp/get-client-idps/'+clientId)
  }
}
